var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566.9,
    height: 566.9,
    viewBox: "0 0 566.9 566.9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1179bf",
    d: "M562.1 283.5c0-154-124.9-278.6-278.6-278.6-154 0-278.6 124.8-278.6 278.6 0 154 124.9 278.6 278.6 278.6s278.6-124.8 278.6-278.6M62.9 162.2h135.7L86.7 438.8h394.6c-46 58.6-117.6 96.1-198 96.1-139 0-251.7-112.7-251.7-251.7.2-43.7 11.4-85 31.3-121m381.8 120.3v-34h-68.2v-86.1h127.2c19.9 36 31.1 77.3 31.1 121.3S523.6 369 503.7 405h-322l111.7-276.6H85.5c46-58.6 117.6-96.1 198-96.1 80.2 0 151.8 37.6 198 96.1H301.6V380h75.1v-97.5h68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZf);
export default __webpack_public_path__ + "static/media/zf.9ff3b76a0c6d13c05cad191c3340d4af.svg";
export { ForwardRef as ReactComponent };